import {createBasicReducer} from '../../utils/redux'
import {basicActions} from './actions'
import {initialState} from './constants'
import {UserState} from './types'

export const reducer = createBasicReducer<UserState>(initialState, basicActions)
